export default __webpack_public_path__ + "static/logo-ed4e7c26e41c64cd9c25b8172b640c5d.png";